export default "__VITE_ASSET__891f029f__"